/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { TableTypeProvider, SampleTypeProvider, TableService } from '@domain/business-layer';
import { DateTimeService, ExpandableCardProperty, FormattingService } from '@shared';
import { WorkBookFileData, TableExpandableCards, FileExporterOption } from '../models';
import { BaseFileExporterService } from './base-file-exporter.service';
import * as XLSX from 'xlsx';
import { DataRepository } from '@database/workspace';
import { FileWriterService } from './file-writer.service';
import { TimeDataFormattingService } from './time-data-formatting.service';

@Injectable()
export class CSVFileExporterService extends BaseFileExporterService {
	public constructor(
		private fileWriterService: FileWriterService,
		protected tableTypeProvider: TableTypeProvider,
		protected sampleTypeProvider: SampleTypeProvider,
		protected tableService: TableService,
		protected dataRepository: DataRepository,
		protected formattingService: FormattingService,
		protected dateTimeService: DateTimeService,
		protected timeDataFormattingService: TimeDataFormattingService
	) {
		super(
			tableTypeProvider,
			sampleTypeProvider,
			tableService,
			dataRepository,
			formattingService,
			dateTimeService,
			timeDataFormattingService
		);
	}

	public async exportData(tablesExpandableCards: TableExpandableCards[]): Promise<void> {
		const csvFileDataArray: WorkBookFileData[] = [];
		console.log(tablesExpandableCards, "ini tablesExpandableCards")

		for (const tableExpandableCards of tablesExpandableCards) {
			const expandableCardsProperties: ExpandableCardProperty[][] = tableExpandableCards.expandableCards.map(
				(expandableCard) => expandableCard.properties
			);
			const itemsMappedInCsvForm: { [key: string]: string }[] =
				this.mapItemsInWorksheetFormat(expandableCardsProperties);

			const workBook: XLSX.WorkBook = XLSX.utils.book_new();
			const workSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(itemsMappedInCsvForm);
			XLSX.utils.book_append_sheet(workBook, workSheet);

			csvFileDataArray.push({
				file: workBook,
				name: tableExpandableCards.tableName
			});
		}
		console.log(csvFileDataArray, "ini csvFileDataArray")

		await this.fileWriterService.writeFile(csvFileDataArray, FileExporterOption.csv);
	}
}
